import React from "react";
import { Row, Col, Grid ,FormGroup,Form,FormControl ,ControlLabel,Checkbox,MenuItem,DropdownButton,ButtonToolbar} from 'react-bootstrap'

class Signwith extends React.Component {
	
	 render() {     
		return (
                  
                  <div className="Signwith">

                  <div className="clearfix">
                  <hr/>

            <Col md={8} mdOffset={2}>

<h3> connect with</h3>
        <Col md={3}>
        <div className="Signwith-holder">
        <a href="#"> <img src={require("../../img/Register/facebook.png")} /></a>
            </div>
        </Col>
        <Col md={3}>
        <div className="Signwith-holder">

        <a href="#"> <img src={require("../../img/Register/twitter.png")} /></a>
        </div>

        </Col>
        <Col md={3}>
        <div className="Signwith-holder">
 
       <a href="#"> <img src={require("../../img/Register/googleplus.png")} /></a>
        </div>

        </Col>
        <Col md={3}>
        <div className="Signwith-holder">

        <a href="#"> <img src={require("../../img/Register/inistgram.png")} /></a>
        </div>

        </Col>
        

        </Col>
        </div>
        </div>


       );
    }
  }
  
  export default Signwith;
  


// WEBPACK FOOTER //
// ./src/Components/Signwith/Signwith.jsx